'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _nitroHeading = require('../nitro-heading');

var _nitroHeading2 = _interopRequireDefault(_nitroHeading);

var _nitroIcon = require('../nitro-icon');

var _nitroIcon2 = _interopRequireDefault(_nitroIcon);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NitroAccordion = function (_Component) {
  _inherits(NitroAccordion, _Component);

  function NitroAccordion(props) {
    _classCallCheck(this, NitroAccordion);

    var _this = _possibleConstructorReturn(this, (NitroAccordion.__proto__ || Object.getPrototypeOf(NitroAccordion)).call(this, props));

    _this.open = function () {
      _this.setState({
        active: true
      });
    };

    _this.close = function () {
      _this.setState({
        active: false
      });
    };

    _this.toggle = function () {
      _this.setState({
        active: !_this.state.active
      });
    };

    _this.state = {
      active: !!_this.props.active
    };
    return _this;
  }

  _createClass(NitroAccordion, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          title = _props.title,
          size = _props.size,
          details = _props.details;


      var direction = this.state.active ? 'up' : 'down';
      var classes = (0, _classnames2.default)('accordion', className);

      return _react2.default.createElement(
        'section',
        { className: classes },
        _react2.default.createElement(
          _styles.Heading,
          { onClick: this.toggle },
          _react2.default.createElement(_nitroHeading2.default, { size: size || '3', label: title, noMargin: true }),
          _react2.default.createElement(
            _styles.AccorionIcon,
            null,
            _react2.default.createElement(_nitroIcon2.default, { name: 'accordion-' + direction, size: 12 })
          )
        ),
        _react2.default.createElement(
          _styles.Content,
          { active: this.state.active },
          details
        )
      );
    }
  }]);

  return NitroAccordion;
}(_react.Component);

NitroAccordion.propTypes = {
  className: _propTypes2.default.string,
  title: _propTypes2.default.string.isRequired,
  details: _propTypes2.default.any.isRequired,
  active: _propTypes2.default.bool,
  size: _propTypes2.default.string
};

exports.default = NitroAccordion;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-accordion/NitroAccordion.js
// module id = 2877
// module chunks = 4